import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetLinkedExternalAccounts = () => {
    const send = useGenericSend();

    return useCallback(async ({ type }: Types.IGetLinkedExternalAccountsRequestData = {}) => {
        const { data } = await send<Types.IGetLinkedExternalAccountsRequestData, Types.IGetLinkedExternalAccountsResponseData>({
            ID: 35954,
            type,
            description: 'Get linked external accounts',
            responses: [35955, 35956]
        });

        return data;
    }, [send]);
};
